import { OptionSubCategory } from 'owa-options-core';
import EventOption from 'owa-calendar-event-option/lib/EventOption';
import InvitationOption from 'owa-calendar-invitation-option/lib/InvitationOption';
import loadCalendarMailboxAndProcessingConfig from './loadCalendarMailboxAndProcessingConfig';

let eventsAndInvitationsSubCategory: OptionSubCategory = {
    key: 'eventAndInvitations',
    titleStringKey: 'optionSubcategory_events_and_invitations',
    options: [EventOption, InvitationOption],
    onSelected: loadCalendarMailboxAndProcessingConfig,
};

export default eventsAndInvitationsSubCategory;
